import styled from "styled-components";

export const InputTextfieldContainer = styled.div`
    position: relative;
    width: 100%;
`;

export const InputTextfield = styled.textarea`
    background: ${props => props.$hasPrefix ? 'transparent' : 'rgba(255, 255, 255, 0.1)'};
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    box-sizing: border-box;
    color: #FFFFFF;
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: 14px;
    font-weight: 500;
    min-height: 96px;
    height: 100%;
    opacity: 0.67;
    outline: none;
    padding: 1.8rem 0.75rem 0.5rem 0.75rem;
    width: 100%;
    resize: vertical;
    transition: all 0.2s ease-out;

    &::placeholder {
        color: #FFFFFF;
    }

    &:focus {
        filter: drop-shadow(2px 2px rgba(0,0,0,0.15));
        opacity: 1.0;
    }

    &:focus + label,
    &:not(:placeholder-shown) + label {
        top: .5rem;
        font-size: 0.75rem;
        color: rgba(255,255,255,0.5);
        background-color: transparent;
    }
`;

export const InputLabel = styled.label`
    position: absolute;
    top: 1.4rem;
    left: 0.75rem;
    pointer-events: none;
    transition: all 0.2s ease-out;
    color: rgba(255,255,255,0.5);
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: 12px;
    font-weight: 500;
`;